import axios from "axios";
import Swal from "sweetalert2";

export const getAllActiveEmployees = async () => {
    try {
        const response = await axios.get("/employees-active");
        return response.data
    } catch (error) {
        console.log(error)
        showWarning('Failed to fetch allowance');
    }
}

export const getEmployeeByUserId = async (userId) => {

        return await axios.get("/getEmpDataByUser/"+userId);

}

const showWarning = (str) => {
    return Swal.fire({
        title: "Error",
        text: str,
        icon: "error",
    });
}


export const getSearchEmployees = async ({
    name,
    epf_number,
    center,
    branch,
    status,
    setLoading,
    startDate,
    endDate,
    departmentName,
    employee_type,
    id, // Add id parameter
    page,
    limit,
    withoutPagination,
  }) => {
    try {
      setLoading(true);
      
      // Extract values from objects if they exist
      const centerValue = center?.value || center || null;
      const branchValue = branch?.value || branch || null;
      const statusValue = status?.value || status || null;
      const employeeTypeValue = employee_type?.value || employee_type || null;
      
      console.log("Search parameters:", {
        name,
        epf_number,
        center: centerValue,
        branch: branchValue,
        status: statusValue,
        startDate,
        endDate,
        departmentName,
        employee_type: employeeTypeValue,
        id,
        page,
        limit,
        withoutPagination,
      });
      const response = await axios.get(`/employees-search`, {
        params: {
          name,
          epf_number,
          center: centerValue,
          branch: branchValue,
          status: statusValue,
          startDate,
          endDate,
          departmentName,
          employee_type: employeeTypeValue,
          id,
          page,
          limit,
          withoutPagination,
        },
        headers: {
          "Cache-Control": "no-cache",
        },
      });
  
      console.log("Search response:", response.data);
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error("Search error:", error.response || error);
      setLoading(false);
      return { status: "error", data: [] };
    }
  };

  export const getShiftById = async (shiftId) => {
  try {
    const response = await axios.get(`/shifts/${shiftId}`); // Adjust endpoint as per your API
    return response.data;
  } catch (error) {
    console.error("Error fetching shift data:", error);
    return null;
  }
};